module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_7.a7fb124a.png";